// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"modal_wrapper__uEJcf","button":"modal_button__l5jH0","header":"modal_header__drwKg"};